// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__RV_5F","tabs-header":"Tabs_tabs-header__kiLy7","tabs-header-tab":"Tabs_tabs-header-tab__VkPaD","tabs-content":"Tabs_tabs-content__gOFCg"};